import React, { useLayoutEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import { assignInlineVars } from '@vanilla-extract/dynamic'

import * as styles from './index.vanilla.css'

type Props = {
  coordinates: {
    x: number
    y: number
  }
  attachment?: styles.Attachment
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const DraggableNode = ({
  children,
  coordinates,
  attachment = 'top right',
  onMouseEnter,
  onMouseLeave,
}: React.PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement>(null)
  const [attachmentByCoords, setAttachmentByCoords] = useState<styles.Attachment>(attachment)

  useLayoutEffect(() => {
    if (coordinates.x - ref.current!.clientWidth < 0) {
      setAttachmentByCoords(attachmentByCoords.replace('right', 'left') as styles.Attachment)
    }
  }, [ref.current])

  return document.body
    ? ReactDOM.createPortal(
        <div
          ref={ref}
          className={styles.attachment[attachmentByCoords]}
          style={assignInlineVars({
            [styles.xPositionVar]: `${coordinates.x}px`,
            [styles.yPositionVar]: `${coordinates.y}px`,
          })}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {children}
        </div>,
        document.body
      )
    : null
}

export default DraggableNode
